module.exports = __webpack_public_path__ + "static/media/S1N6-3.9f340551.svg";